import { fetchTableData, refresh } from '../tables';
import { artists, events } from '../../../services/api.admin';
import { PERMISSIONS, hasPermissions } from '../../../constants/authentication/permissions';
import { currentUserSelector } from '../../../selectors/authentication';
import { fetchDependencies } from '../modal.forms';
import { ADMIN_ARTISTS_DETAILS_PATH } from '../../../constants/routes';
import { push } from 'react-router-redux';
import { ADMIN_MODAL_FORMS, ADMIN_TABLES, ADMIN_FLASH } from '../../../constants/actions';
import { formDataSelector } from '../../../selectors/admin/forms';
import { dependenciesSelector } from '../../../selectors/admin/modal.forms';
import { MODELS } from '../../../constants/admin/settings';
import { apiMultipleCalls } from '../../helpers';
import { apiDataToState, stateToApiData } from '../../../selectors/admin/models/artists';
import { selectedSelector } from '../../../selectors/admin/tables';
import { forEach, filter, find, map, uniqBy, uniq, flatten } from 'lodash';

export function fetchEventArtistsWithContractStatus(eventId, pagination, context) {
    return fetchTableData(() => artists.getForEvent(eventId, context, pagination, true), 'artists', {
        pagination
    });
}

export function fetchEventArtists(eventId, pagination, context) {
    return fetchTableData(() => artists.getForEvent(eventId, context, pagination), 'artists', {
        pagination
    });
}

export function fetchEventArtistDependencies(context) {
    return (dispatch, getState) => {
        const user = currentUserSelector(getState());
        const dependencies = [];
        if (hasPermissions(user, PERMISSIONS.ARTISTS_VIEW)) {
            dependencies.push(context ? () => artists.getOrgAll(context) : artists.getAll);
        }
        if (hasPermissions(user, PERMISSIONS.EVENTS_VIEW)) {
            dependencies.push(context ? () => events.getOrgAll(context) : events.getAll);
        }
        dispatch(fetchDependencies(dependencies));
    };
}

export function openEventArtist(ea) {
    return push(ADMIN_ARTISTS_DETAILS_PATH.replace(':artistId', ea.id));
}

export function createEventArtist(data, eventId) {
    return (dispatch, getState) => {
        dispatch({ type: ADMIN_MODAL_FORMS.SUBMIT });
        const organizationId = formDataSelector(getState(), { model: MODELS.EVENT }).organizationId;
        const artistsList = dependenciesSelector(getState()).artists;
        const artistsDataManual = data.artistIds.map(x => find(artistsList, y => y.id === x));
        const artistsDataEvent = flatten(
            data.eventIds.map(x => filter(artistsList, y => (y.eventIds || []).includes(x)))
        );

        const artistsData = uniqBy(artistsDataManual.concat(artistsDataEvent), x => x.id);
        dispatch({ type: ADMIN_MODAL_FORMS.SUBMIT });
        // TODO-NT Write a better back-end call to do this (bulk?)
        return apiMultipleCalls(
            dispatch,
            artistsData.map(x => () => artists.getMember(x.id)),
            resp => {
                return apiMultipleCalls(
                    dispatch,
                    map(
                        resp,
                        v => () =>
                            artists.update(
                                v.id,
                                stateToApiData({
                                    ...apiDataToState(v),
                                    organizationIds: uniq([...v.organizationIds, organizationId]),
                                    eventIds: uniq([...v.eventIds, eventId])
                                })
                            )
                    ),
                    () => {
                        dispatch({ type: ADMIN_MODAL_FORMS.SUCCESS });
                        dispatch(refresh());
                        dispatch({
                            type: ADMIN_FLASH.OPEN,
                            message: `${artistsData.length} artist${
                                artistsData.length === 1 ? '' : 's'
                            } added to the event.`
                        });
                    }
                );
            },
            0,
            {},
            true
        );
    };
}

export function deleteEventArtists(eventId) {
    return (dispatch, getState) => {
        const tableIndex = 0;
        dispatch({ type: ADMIN_TABLES.DISABLE, index: tableIndex });
        const selected = selectedSelector(getState(), {});
        // TODO-NT Write a better back-end call to do this (bulk?)
        return apiMultipleCalls(
            dispatch,
            selected.map(s => () => artists.getMember(s)),
            resp => {
                const updateCalls = [];
                forEach(resp, art => {
                    const artistData = apiDataToState(art);
                    artistData.eventIds = filter(artistData.eventIds, x => x !== eventId);
                    updateCalls.push(() => artists.update(artistData.id, stateToApiData(artistData)));
                });
                return apiMultipleCalls(dispatch, updateCalls, () => {
                    dispatch({ type: ADMIN_TABLES.DELETE, index: tableIndex, removed: selected });
                    dispatch({
                        type: ADMIN_FLASH.OPEN,
                        message: `${selected.length} artist${selected.length === 1 ? '' : 's'} removed from the event.`
                    });
                    dispatch(refresh());
                });
            },
            0,
            {},
            true
        );
    };
}
